export default "__VITE_ASSET__9gthzYyl__"